import { render, staticRenderFns } from "./EmailValidate.vue?vue&type=template&id=59621c00&scoped=true"
import script from "./EmailValidate.vue?vue&type=script&lang=js"
export * from "./EmailValidate.vue?vue&type=script&lang=js"
import style0 from "./EmailValidate.vue?vue&type=style&index=0&id=59621c00&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59621c00",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kemingchen/Projects/VisionFutureWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59621c00')) {
      api.createRecord('59621c00', component.options)
    } else {
      api.reload('59621c00', component.options)
    }
    module.hot.accept("./EmailValidate.vue?vue&type=template&id=59621c00&scoped=true", function () {
      api.rerender('59621c00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Register/EmailValidate.vue"
export default component.exports